import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { api } from '../api';
import Ayuda from '../ui/Ayuda';

/* =====================================================================
   Avisos y conservación · CUMPLIMIENTO F5 y F6 (del dueño)
   =====================================================================
   Solo se ve: declarar una versión vigente y confirmar un plazo se hacen
   desde el servidor con nombre y fecha. Aquí el dueño comprueba qué rige
   y qué falta por confirmar.
   ===================================================================== */
export default function AvisosYConservacion() {
  const [av, setAv] = useState(null);
  const [co, setCo] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let vivo = true;
    Promise.all([api.get('/cumplimiento/avisos'), api.get('/cumplimiento/conservacion')])
      .then(([a, c]) => { if (vivo) { setAv(a); setCo(c); } })
      .catch((e) => { if (vivo) setError(e.message); });
    return () => { vivo = false; };
  }, []);
  if (error) return <p className="p-4 text-sm text-red-700">{error}</p>;
  if (!av || !co) {
    return (
      <p className="flex items-center gap-2 p-4 text-sm text-gray-500">
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> Leyendo avisos y plazos…
      </p>
    );
  }
  return (
    <div className="flex max-w-5xl flex-col gap-6 p-4">
      <header>
        <h1 className="text-xl font-semibold text-gray-900">Avisos y conservación</h1>
        <p className="text-gray-600">Qué texto legal rige y cuánto tiempo se guarda cada cosa.</p>
        <Ayuda id="cumplimiento.avisos.pantalla" />
      </header>

      <section className="rounded-xl border border-gray-200 p-4">
        <h2 className="font-semibold text-gray-900">Versiones de los textos legales</h2>
        <Ayuda id="cumplimiento.avisos.huella" />
        {av.versiones.length === 0 ? (
          <p className="text-sm text-gray-600">Ninguna versión registrada: los textos siguen como borrador y no se exige aceptar nada. Se registra desde el servidor con <code>python -m app.cumplimiento.cli registrar-aviso</code>.</p>
        ) : (
          <div className="overflow-x-auto"><table className="mt-2 min-w-full text-sm">
            <thead><tr className="text-left text-gray-500"><th className="pr-3">Documento</th><th className="pr-3">Versión</th><th className="pr-3">Estado</th><th className="pr-3">Desde</th><th className="pr-3">Huella</th><th className="pr-3">Aceptaciones</th></tr></thead>
            <tbody>{av.versiones.map((v) => (
              <tr key={v.id} className={v.estado === 'VIGENTE' ? 'font-medium text-gray-900' : 'text-gray-600'}>
                <td className="pr-3">{v.clave}</td><td className="pr-3">{v.version}</td>
                <td className="pr-3"><span className={`rounded px-2 text-xs ${v.estado === 'VIGENTE' ? 'bg-green-50 text-green-800' : 'bg-gray-100'}`}>{v.estado}</span></td>
                <td className="pr-3">{v.vigente_desde || '—'}</td>
                <td className="pr-3 font-mono text-xs">{v.huella.slice(0, 12)}…{av.en_disco[v.clave] === v.huella ? '' : ' (el archivo cambió)'}</td>
                <td className="pr-3 tabular-nums">{v.aceptaciones}</td>
              </tr>))}</tbody>
          </table></div>
        )}
        <p className="mt-2 text-xs text-gray-500">Puntos donde se pide: {Object.entries(av.puntos).map(([p, l]) => `${p.replace('_', ' ')} (${l.length ? l.map((x) => `${x.clave} ${x.version}`).join(', ') : 'nada vigente'})`).join(' · ')}</p>
      </section>

      <section className="rounded-xl border border-gray-200 p-4">
        <h2 className="font-semibold text-gray-900">Cuánto tiempo se guarda cada cosa</h2>
        <p className="text-sm text-gray-600">{co.dice} Confirmados: <strong>{co.confirmados}</strong> de {co.total}.</p>
        <Ayuda id="cumplimiento.conservacion.confirmado" />
        <div className="overflow-x-auto"><table className="mt-2 min-w-full text-sm">
          <thead><tr className="text-left text-gray-500"><th className="pr-3">Tipo</th><th className="pr-3">Base</th><th className="pr-3">Plazo</th><th className="pr-3">Al vencer</th><th className="pr-3">Confirmado</th></tr></thead>
          <tbody>{co.plazos.map((p) => (
            <tr key={p.tipo_dato} className="align-top">
              <td className="pr-3 font-medium text-gray-900">{p.descripcion}</td>
              <td className="pr-3 text-gray-600">{p.base_legal}</td>
              <td className="pr-3 text-gray-700">{p.plazo_texto}</td>
              <td className="pr-3"><span className="rounded bg-gray-100 px-2 text-xs">{p.accion_al_vencer}</span></td>
              <td className="pr-3">{p.confirmado ? <span className="text-green-800">{p.confirmado_por} · {p.confirmado_en}</span> : <span className="text-amber-700">Sin confirmar</span>}</td>
            </tr>))}</tbody>
        </table></div>
      </section>
    </div>
  );
}
